import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
var Checkbox2 = function (_a) {
    var checked = _a.checked, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (React.createElement("div", { className: "h-6 w-6 rounded-[4px] border-2 border-solid ".concat(checked ? 'border-primary bg-primary' : 'border-[#919CC2] bg-white', " flex items-center justify-center flex-shrink-0 transition-all\n    ").concat(disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer', "\n    ") }, checked && React.createElement(FontAwesomeIcon, { icon: faCheck, size: "sm", color: "white" })));
};
export default Checkbox2;
